import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Box from "@mui/joy/Box";
import {setPanelKey} from "../../../store/reducers/panleKey";
import {setColorType, setSVGColorObject} from "../../../store/reducers/colorReducer";
import {getIconColors} from "../../../utils/helpers";

const ExpandableColorHolder = ({heading, colors, className, ...props}) => {
    const [size, setSize] = useState(8);
    const [iconColors, setIconColors] = useState([]);
    const {activeObject} = useSelector((state) => state.canvas);
    const [activeColors, setActiveColors] = useState([]);

    const dispatch = useDispatch()

    useEffect(() => {
        if (activeObject && colors) {
            if (activeObject.type === 'group') {
                let tempArray = [];
                activeObject._objects.forEach((obj, index) => {
                    tempArray.push({id: index, value: obj.fill})
                })
                setIconColors([...tempArray])
            } else
                setIconColors([...colors])
        }
    }, [])

    useEffect(() => {
        if(!activeObject) return;
        if(colors) {
            setActiveColors(colors);
            setIconColors(colors);
        }
        else{
            let svgColorArray = getIconColors(activeObject, 'fill'),
                svgStrokeArray = getIconColors(activeObject, 'stroke');

            let filteredColors = [];
            svgColorArray.map((color) => {
                if (!filteredColors.find((col) => col.color === color.value))
                    filteredColors.push({index: color.id, color: color.value})
            })
            activeObject.set({
                svgColorArray: svgColorArray,
                svgStrokeArray: svgStrokeArray,

            })
            setActiveColors(svgColorArray || []);
            setIconColors(svgColorArray || []);
        }
    },[colors])

    return (
        <div>
            <label>{heading}</label>
            <Box sx={{py: 1, width: '100%'}}>
                <Box sx={{display: 'flex', flexWrap: 'row', gap: 1}}>
                    {
                        activeColors?.slice(0, size).map((color, index) => {
                            return (
                                <div onClick={() => {
                                    dispatch(setPanelKey('colorPicker'))
                                    dispatch(setColorType('svg'))
                                    dispatch(setSVGColorObject(color))
                                }} key={index} style={{backgroundColor: color.value}} className='color-pallet'>
                                </div>
                            )
                        })
                    }
                </Box>
            </Box>
        </div>

    );
}

export default ExpandableColorHolder;

